import * as React from 'react';

function SvgBounced(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.167 2.5H5.834c-2.5 0-4.167 1.25-4.167 4.167V12.5c0 2.917 1.667 4.167 4.167 4.167h2.975c.491 0 .891-.434.825-.925a5.507 5.507 0 01.058-1.842c.442-2.167 2.225-3.892 4.408-4.25a5.424 5.424 0 013.05.375c.559.242 1.184-.142 1.184-.75V6.667c0-2.917-1.667-4.167-4.167-4.167zm.392 4.658L11.95 9.242c-.55.441-1.25.658-1.95.658s-1.408-.217-1.95-.658L5.442 7.158a.64.64 0 01-.1-.883.623.623 0 01.875-.1l2.608 2.083c.634.509 1.709.509 2.342 0l2.608-2.083a.615.615 0 01.875.1.631.631 0 01-.091.883z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.833 15A4.163 4.163 0 0115 10.833 4.158 4.158 0 0119.166 15c0 2.3-1.858 4.166-4.166 4.166A4.168 4.168 0 0110.833 15zm2.342-1.853a.5.5 0 01.707-.001L15 14.258l1.078-1.073a.5.5 0 01.705.709l-1.074 1.07 1.104 1.1a.5.5 0 01-.706.708L15 15.67l-1.146 1.141a.5.5 0 01-.706-.708l1.144-1.14-1.114-1.109a.5.5 0 01-.002-.707z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgBounced;
